import React from 'react';
import { cn } from '@/lib/utils';
import type { TabDefinition } from '../types';

export interface StatusTabsProps {
  tabs: TabDefinition[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
}

export const StatusTabs: React.FC<StatusTabsProps> = ({ tabs, activeTab, onTabChange }) => (
  <div className="w-full pt-3 pb-4">
    <div className="w-full rounded-xl bg-gray-100 px-1 py-1 flex gap-1 items-stretch flex-nowrap" role="tablist" aria-label="Status Tabs">
      {tabs.map((tab) => {
        const isActive = activeTab === tab.id;
        return (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            role="tab"
            aria-selected={isActive}
            className={cn(
              'flex-1 basis-0 h-9 sm:h-10 px-4 text-sm font-semibold rounded-lg transition-colors flex items-center justify-center gap-2',
              isActive
                ? 'bg-white text-sky-700 border border-sky-200 shadow-sm'
                : 'text-gray-600 hover:text-gray-900'
            )}
          >
            <span>{tab.label}</span>
            {tab.count !== undefined && (
              <span
                className={cn(
                  'inline-flex items-center justify-center px-2 py-0.5 text-xs font-semibold rounded-full',
                  isActive ? 'bg-sky-100 text-sky-700' : 'bg-gray-200 text-gray-600'
                )}
              >
                {tab.count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  </div>
);
